import React from "react";
import ESIPage from "@/components/esi-page/ESIPage";

function generateMetadata() {
  return {
    title: "Important shop Information",
    description: `Customer services information at John Lewis & Partners`,
  };
}

function Page() {
  return <ESIPage />;
}

Page.generateMetadata = generateMetadata;

export default Page;
